import * as React from "react";
// import AuthService from "../services/AuthService";

// const Auth = new AuthService();

const storedToken =
  sessionStorage.getItem("authToken") !== null
    ? sessionStorage.getItem("authToken")
    : "";

const ctxt = React.createContext({
  isAuthenticated: false,
  authToken: storedToken,
  testValue: 5,
  login: () => {},
  logout: () => {},
});

export const MainContextProvider = ctxt.Provider;

export const MainContextConsumer = ctxt.Consumer;

export default ctxt;
